import { StarFilled, StarOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { CustomDrawer } from 'components/ui';
import { useEditFormStore } from 'stores/local';

import { FieldColumns } from '../../common';

type Props = {
  showOnlySelected: boolean;
};

const MyFields: React.FC<Props> = ({ showOnlySelected }: Props) => {
  const { t } = useTranslation();
  const { editFormStore } = useEditFormStore();

  return (
    <CustomDrawer.Body
      collapse={{
        expandIcon: ({ isActive }) =>
          isActive ? <StarFilled /> : <StarOutlined />,
      }}
      header={
        <Typography.Text type="secondary">
          {t('editForm.myFieldsTitle', {
            count: editFormStore.formStore.catalogStore.data.myFields.length,
          })}
        </Typography.Text>
      }
    >
      <FieldColumns
        showOnlySelected={showOnlySelected}
        catalogDrawerControllerStore={
          editFormStore.catalogDrawerControllerStore
        }
        fields={{
          ['group']: editFormStore.formStore.catalogStore.data.myFields,
        }}
      />
    </CustomDrawer.Body>
  );
};

export default observer(MyFields);
